export default "__VITE_ASSET__yaPE9anF__"